if (!customElements.get('bfp-purchase-bar')) {
  customElements.define('bfp-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.button = this.querySelector('button');
      this.sync = () => {
        const source = this.main?.querySelector('product-form button[type="submit"]');
        if (!source) return;
        this.button.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
        this.button.querySelector('span').textContent = source.querySelector('span')?.textContent.trim();
        this.button.setAttribute('aria-busy', source.classList.contains('loading') ? 'true' : 'false');
        const price = this.main.querySelector('.price__sale .price-item--sale') || this.main.querySelector('.price__regular .price-item--regular');
        if (price) this.querySelector('.bfp-bar-price').textContent = price.textContent.trim();
      };
      if (this.main) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.main, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','class']});
        this.sync();
      }
      this.errorHandler = (event) => {
        if (event.target.closest('form')?.id !== this.button.getAttribute('form')) return;
        const error = this.main?.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (error) error.scrollIntoView({behavior:'smooth',block:'center'});
      };
      this.main?.addEventListener('submit', this.errorHandler);
      const positionReviews = () => {
        const reviews = document.getElementById('vitals-end-section');
        const footer = document.querySelector('.bfp-footer-start');
        if (!reviews || !footer) return;
        if (reviews.nextElementSibling !== footer) footer.before(reviews);
        this.reviewsObserver?.disconnect();
      };
      this.reviewsObserver = new MutationObserver(positionReviews);
      const content = document.getElementById('MainContent');
      if (content) this.reviewsObserver.observe(content, {childList:true,subtree:true});
      positionReviews();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.reviewsObserver?.disconnect();
      this.main?.removeEventListener('submit', this.errorHandler);
    }
  });
}
